export default __webpack_public_path__ + "static/favorites-751013f545f84d5627e206fe38bbe515.jpg";